const HISTORY_TTL = 30 * 60 * 1000
const MAX_HISTORY_DELIVERIES = 50

export default {
  namespaced: true,
  state: () => ({
    deliveries: null,
    lastUpdated: null
  }),
  mutations: {
    setDeliveries(state, deliveries) {
      state.deliveries = Array.isArray(deliveries)
        ? deliveries.slice(0, MAX_HISTORY_DELIVERIES)
        : null
      state.lastUpdated = Date.now()
    },
    clearDeliveries(state) {
      state.deliveries = null
      state.lastUpdated = null
    },
    pruneDeliveries(state) {
      if (!state.lastUpdated || Date.now() - state.lastUpdated > HISTORY_TTL) {
        state.deliveries = null
        state.lastUpdated = null
        return
      }

      if (Array.isArray(state.deliveries) && state.deliveries.length > MAX_HISTORY_DELIVERIES) {
        state.deliveries = state.deliveries.slice(0, MAX_HISTORY_DELIVERIES)
      }
    }
  },
  getters: {
    getDeliveries: (state) => {
      if (!state.lastUpdated || Date.now() - state.lastUpdated > HISTORY_TTL) {
        return null
      }
      return state.deliveries
    }
  }
}
